import axios from '@axios'
export default {
    namespaced: true,
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchGroups(ctx, queryParams) {
            var data = JSON.stringify(queryParams);
            
            return new Promise((resolve, reject) => {
              axios
                .post('/groups/v1/getall',data)
                .then(response => resolve(response))
                .catch(error => reject(error))
            })
        },
    }
}